import { render } from "./TableTaxonomies.vue?vue&type=template&id=1bf98818&scoped=true"
import script from "./TableTaxonomies.vue?vue&type=script&lang=js"
export * from "./TableTaxonomies.vue?vue&type=script&lang=js"

import "./TableTaxonomies.vue?vue&type=style&index=0&id=1bf98818&lang=sass&scoped=true"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf98818"]])

export default __exports__